const QUIZ_STATE = {
    UNAVAILABLE: 'unavailable',
    NOT_ATTEMPTED: 'undefined',
    MASTERED: 'mastered',
    PASSED: 'passed',
    NOT_PASSED: 'failed',
}

export default QUIZ_STATE
